import React from "react";
import { globalFileServer, globalFileIcon } from "../../../axiosInstance";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="legal-details">
        <a
          target="_blank"
          className="privacy"
          href={globalFileServer + "med.pdf"}
        >
          תקנון האתר |
        </a>
        <a
          target="_blank"
          className="privacy"
          href={globalFileServer + "privacy.pdf"}
        >
          {" "}
          מדיניות הפרטיות{" "}
        </a>
        <a
          target="_blank"
          className="privacy"
          href={globalFileServer + "accessibility.pdf"}
        >
          | הצהרת נגישות{" "}
        </a>
        <NavLink
          className="privacy"
          to="/workers-needed"
          target="_self"
          onClick={() => window.scrollTo(0, 0)}
        >
          | דרושים{" "}
        </NavLink>
      </div>
      <div className="sub-footer">
        <a className="click-and">
          <img
            loading="lazy"
            src={globalFileIcon + "hand-click.svg"}
            alt="hand-click"
          />
          <h3>קליק וקיבלת</h3>
          <h5>24 שעות אצלך בבית</h5>
        </a>
        <a className="click-and">
          <img
            loading="lazy"
            src={globalFileIcon + "chose-click.svg"}
            alt="chose-click"
          />
          <h3>קליק ובחרת</h3>
          <h5>הכשרים מהודרים לכל המוצרים</h5>
        </a>
        <a className="click-and">
          <img
            loading="lazy"
            src={globalFileIcon + "earn-click.svg"}
            alt="earn-click"
          />
          <h3>קליק והרווחת</h3>
          <h5>עשרות מבצעים שווים!</h5>
        </a>
      </div>
      <div className="copyright">
        <img
          loading="lazy"
          src={globalFileIcon + "footer-site.svg"}
          alt="footer-site"
        />
        <span>כל הזכויות שמורות להמזון בע"מ</span>
      </div>
    </footer>
  );
};
export default Footer;
